// Libs
import React, { useContext } from "react";
import { withLDProvider } from "launchdarkly-react-client-sdk";
import PropTypes from "prop-types";

// Contexts
import FeatureSwitchContext from "contexts/FeatureSwitch";
import UrlSponsorContext from "contexts/UrlSponsor";

function LaunchDarklyProvider({ app }) {
  // Get LaunchDarkly client ID for current env from Employer-Backend's env variables
  const {
    features: { launchDarklyClientSideId }
  } = useContext(FeatureSwitchContext);

  const urlSponsor = useContext(UrlSponsorContext);
  const { id, name } = urlSponsor;
  const user =
    id !== undefined && name !== undefined
      ? {
          key: `${id}-${name}`,
          custom: {
            sponsorId: id
          }
        }
      : {};

  // Initialize LaunchDarkly's React SDK using client ID
  // https://docs.launchdarkly.com/sdk/client-side/react/react-web
  const AppWithLDProvider = withLDProvider({
    clientSideID: launchDarklyClientSideId[0],
    user
  })(app);
  const App = app;

  // if LaunchDarkly client id is present, wrap app in LD provider, else render app normally
  return launchDarklyClientSideId[0].length ? <AppWithLDProvider /> : <App />;
}

LaunchDarklyProvider.propTypes = {
  /**
   * React app component function to be launched.
   */
  app: PropTypes.func.isRequired
};

export default LaunchDarklyProvider;
